<template>
  <div class="special-meal-config-view pa-4">
    <!-- 1. Header / Tarjeta de Título Neutra (sunexpert-frontend-ui) -->
    <v-card class="mb-4 rounded-xl border-light bg-white" outlined elevation="0">
      <v-card-title class="d-flex align-center py-4 px-5 flex-wrap">
        <v-avatar color="grey lighten-4" size="44" class="mr-3">
          <v-icon color="primary">mdi-food-fork-drink</v-icon>
        </v-avatar>
        <div>
          <h2 class="text-h6 font-weight-black grey--text text--darken-4 mb-0">
            Configuración de Almuerzo Especial
          </h2>
          <span class="text-caption grey--text text--darken-2">
            Gestión de asignación de almuerzo especial con cobertura 100% empresa (por Puesto y por Persona).
          </span>
        </div>
      </v-card-title>
    </v-card>

    <!-- 2. Pestañas de Navegación Neutras y Contenedores CRUD -->
    <v-card class="rounded-xl border-light bg-white overflow-hidden" outlined elevation="0">
      <v-tabs
        v-model="tab"
        color="primary"
        slider-color="primary"
        background-color="transparent"
        class="border-light-bottom"
      >
        <v-tab class="text-none font-weight-bold px-6">
          <v-icon left small>mdi-briefcase-account-outline</v-icon>
          Por Puesto
        </v-tab>
        <v-tab class="text-none font-weight-bold px-6">
          <v-icon left small>mdi-account-multiple-check-outline</v-icon>
          Por Persona
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab">
        <!-- PESTAÑA 1: POR PUESTO -->
        <v-tab-item class="pa-4">
          <s-crud
            ref="crudPosition"
            :config="configPosition"
            :filter="filterPosition"
            @save="savePosition($event)"
            add
            edit
            remove
            title="Puestos Asignados"
          >
            <template v-slot="props">
              <v-card class="rounded-xl border-light bg-white pa-4 my-2" outlined elevation="0">
                <div class="d-flex align-center mb-3">
                  <v-icon color="primary" small class="mr-2">mdi-briefcase-edit-outline</v-icon>
                  <span class="text-subtitle-2 font-weight-bold grey--text text--darken-4 text-uppercase">
                    Datos del Puesto
                  </span>
                </div>
                <v-divider class="mb-4"></v-divider>

                <v-row dense>
                  <v-col cols="12">
                    <s-select-position
                      v-model="props.item.PstID"
                      :text="props.item.PstName"
                      label="Puesto *"
                      clearable
                    />
                  </v-col>
                  <v-col cols="12" md="6" class="mt-2">
                    <s-date
                      v-model="props.item.SmcValidityInit"
                      label="Fecha Inicio Vigencia *"
                    />
                  </v-col>
                  <v-col cols="12" md="6" class="mt-2">
                    <s-date
                      v-model="props.item.SmcValidityEnd"
                      label="Fecha Fin Vigencia"
                      clearable
                    />
                  </v-col>
                  <v-col cols="12" class="mt-2">
                    <s-switch
                      v-model="props.item.SmcStatus"
                      label="Estado Activo"
                      :true-value="1"
                      :false-value="0"
                      color="primary"
                    />
                  </v-col>
                </v-row>
              </v-card>
            </template>

            <template v-slot:SmcStatus="{ row }">
              <v-chip
                x-small
                :color="row.SmcStatus == 1 ? 'success' : 'grey lighten-2'"
                :class="row.SmcStatus == 1 ? 'white--text font-weight-bold' : 'grey--text text--darken-3 font-weight-medium'"
                label
              >
                <v-icon x-small left :color="row.SmcStatus == 1 ? 'white' : 'grey darken-2'">
                  {{ row.SmcStatus == 1 ? 'mdi-check-circle' : 'mdi-close-circle' }}
                </v-icon>
                {{ row.SmcStatus == 1 ? 'Activo' : 'Inactivo' }}
              </v-chip>
            </template>
          </s-crud>
        </v-tab-item>

        <!-- PESTAÑA 2: POR PERSONA -->
        <v-tab-item class="pa-4">
          <s-crud
            ref="crudPerson"
            :config="configPerson"
            :filter="filterPerson"
            @save="savePerson($event)"
            add
            edit
            remove
            title="Personas Asignadas"
          >
            <template v-slot="props">
              <v-card class="rounded-xl border-light bg-white pa-4 my-2" outlined elevation="0">
                <div class="d-flex align-center mb-3">
                  <v-icon color="primary" small class="mr-2">mdi-account-edit-outline</v-icon>
                  <span class="text-subtitle-2 font-weight-bold grey--text text--darken-4 text-uppercase">
                    Datos de la Persona
                  </span>
                </div>
                <v-divider class="mb-4"></v-divider>

                <v-row dense>
                  <v-col cols="12" md="5">
                    <s-toolbar-person
                      noCamera
                      label="Documento *"
                      v-model="props.item.PrsDocumentNumber"
                      @returnPerson="returnPerson($event, props.item)"
                    />
                  </v-col>
                  <v-col cols="12" md="7">
                    <s-text
                      v-model="props.item.PersonFullName"
                      label="Persona / Trabajador *"
                      readonly
                    />
                  </v-col>
                  <v-col cols="12" md="6" class="mt-2">
                    <s-date
                      v-model="props.item.SmcValidityInit"
                      label="Fecha Inicio Vigencia *"
                    />
                  </v-col>
                  <v-col cols="12" md="6" class="mt-2">
                    <s-date
                      v-model="props.item.SmcValidityEnd"
                      label="Fecha Fin Vigencia"
                      clearable
                    />
                  </v-col>
                  <v-col cols="12" class="mt-2">
                    <s-switch
                      v-model="props.item.SmcStatus"
                      label="Estado Activo"
                      :true-value="1"
                      :false-value="0"
                      color="primary"
                    />
                  </v-col>
                </v-row>
              </v-card>
            </template>

            <template v-slot:SmcStatus="{ row }">
              <v-chip
                x-small
                :color="row.SmcStatus == 1 ? 'success' : 'grey lighten-2'"
                :class="row.SmcStatus == 1 ? 'white--text font-weight-bold' : 'grey--text text--darken-3 font-weight-medium'"
                label
              >
                <v-icon x-small left :color="row.SmcStatus == 1 ? 'white' : 'grey darken-2'">
                  {{ row.SmcStatus == 1 ? 'mdi-check-circle' : 'mdi-close-circle' }}
                </v-icon>
                {{ row.SmcStatus == 1 ? 'Activo' : 'Inactivo' }}
              </v-chip>
            </template>
          </s-crud>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </div>
</template>

<script>
import SpecialMealConfigService from "@/services/DinningHall/SpecialMealConfigService";
import sToolbarPerson from "@/components/Utils/Person/sToolbarPerson";

export default {
  name: "SpecialMealConfig",
  components: {
    sToolbarPerson,
  },
  data: () => ({
    tab: null,
    filterPosition: {
      SmcTypeConfig: 1,
      SecStatus: 1,
    },
    filterPerson: {
      SmcTypeConfig: 2,
      SecStatus: 1,
    },
    configPosition: {
      model: {
        SmcID: "ID",
        SmcTypeConfig: "int",
        PstID: "ID",
        NtpID: "int",
        SmcValidityInit: "date",
        SmcValidityEnd: "date",
        SmcStatus: 1,
        SecStatus: 1,
        UsrCreateID: "int",
        UsrUpdateID: "int",
      },
      service: SpecialMealConfigService,
      headers: [
        { text: "ID", value: "SmcID", sortable: false },
        { text: "Puesto", value: "PstName", sortable: false },
        { text: "Área", value: "AreName", sortable: false },
        { text: "Inicio Vigencia", value: "SmcValidityInit", sortable: false },
        { text: "Fin Vigencia", value: "SmcValidityEnd", sortable: false },
        { text: "Estado", value: "SmcStatus", sortable: false },
      ],
    },
    configPerson: {
      model: {
        SmcID: "ID",
        SmcTypeConfig: "int",
        PstID: "int",
        NtpID: "ID",
        PrsDocumentNumber: "string",
        PersonFullName: "string",
        SmcValidityInit: "date",
        SmcValidityEnd: "date",
        SmcStatus: 1,
        SecStatus: 1,
        UsrCreateID: "int",
        UsrUpdateID: "int",
      },
      service: SpecialMealConfigService,
      headers: [
        { text: "ID", value: "SmcID", sortable: false },
        { text: "Documento", value: "PrsDocumentNumber", sortable: false },
        { text: "Persona", value: "PersonFullName", sortable: false },
        { text: "Inicio Vigencia", value: "SmcValidityInit", sortable: false },
        { text: "Fin Vigencia", value: "SmcValidityEnd", sortable: false },
        { text: "Estado", value: "SmcStatus", sortable: false },
      ],
    },
  }),

  methods: {
    returnPerson(data, item) {
      if (data && data.NtpID) {
        item.NtpID = data.NtpID;
        item.PrsDocumentNumber = data.PrsDocumentNumber;
        item.PersonFullName = data.PrsFullName || data.NtpFullName || data.PrsName || data.PersonFullName;
      } else {
        item.NtpID = null;
        item.PersonFullName = "";
      }
    },
    savePosition(item) {
      item.SmcTypeConfig = 1;
      item.NtpID = null;
      if (!item.PstID) {
        this.$fun.alert("Debe seleccionar un Puesto", "warning");
        return;
      }
      if (!item.SmcValidityInit) {
        this.$fun.alert("Debe ingresar Fecha Inicio Vigencia", "warning");
        return;
      }
      // Al crear nuevo registro, asegurar SmcStatus = 1; al editar, respetar selección del usuario
      if (!item.SmcID || item.SmcID === 0) {
        item.SmcStatus = (item.SmcStatus === 0 || item.SmcStatus === false) ? 0 : 1;
        item.SecStatus = 1;
      } else {
        item.SmcStatus = (item.SmcStatus === 1 || item.SmcStatus === true) ? 1 : 0;
      }
      item.save();
    },
    savePerson(item) {
      item.SmcTypeConfig = 2;
      item.PstID = null;
      if (!item.NtpID || item.NtpID === 0) {
        this.$fun.alert("Debe seleccionar una Persona válida del catálogo", "warning");
        return;
      }
      if (!item.SmcValidityInit) {
        this.$fun.alert("Debe ingresar Fecha Inicio Vigencia", "warning");
        return;
      }
      // Al crear nuevo registro, asegurar SmcStatus = 1; al editar, respetar selección del usuario
      if (!item.SmcID || item.SmcID === 0) {
        item.SmcStatus = (item.SmcStatus === 0 || item.SmcStatus === false) ? 0 : 1;
        item.SecStatus = 1;
      } else {
        item.SmcStatus = (item.SmcStatus === 1 || item.SmcStatus === true) ? 1 : 0;
      }
      item.save();
    },
  },
};
</script> 

<style scoped>
.border-light {
  border: 1px solid #e2e8f0 !important;
}

.border-light-bottom {
  border-bottom: 1px solid #e2e8f0 !important;
}

.bg-white {
  background-color: #ffffff !important;
}

.bg-grey-light {
  background-color: #f8fafc !important;
}
</style>
